/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React from "react"
import { createRoot } from "react-dom/client"
import axios, { AxiosError } from "axios"

import "./theme-exfluency.css"

import UserService from "./UserService"
import AppProviders, { NoUserContextAppProviders } from "./providers/AppProviders"
import { BiPortalApp } from "./BiPortal"
import { NoConnectionError, RequestError } from "src/models/errors"
import { Route, Routes } from "react-router-dom"
import ChatBotPage from "./km/pages/chatbot/ChatBotPage"
import { MainWrapper } from "./components/MainWrapper"

const CONTENT_TYPE = "application/json"
const CONTENT_TYPE_HEADER = "Content-Type"
axios.defaults.headers.post[CONTENT_TYPE_HEADER] = CONTENT_TYPE
axios.defaults.headers.get[CONTENT_TYPE_HEADER] = CONTENT_TYPE
axios.defaults.headers.put[CONTENT_TYPE_HEADER] = CONTENT_TYPE
axios.interceptors.request.use((config) =>
  UserService.unauthenticatedPath()
    ? Promise.resolve(config)
    : new Promise((resolve) =>
        UserService.updateToken(async () => {
          const token = await UserService.getToken()
          if (token && !!config && !!config.headers) config.headers.Authorization = `Bearer ${token}`
          resolve(config)
        })
      )
)
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    handleNetworkError(error)
    // return Promise.reject(error)
  }
)

/**
 * Handle network error (This method always throw an error)
 *
 * Validate received error and create
 * a valid NetworkError Class instance.
 * Each object has additional methods to debug
 * or process received error codes.
 *
 * @param error - Error instance to check.
 */
function handleNetworkError(error: AxiosError): never {
  if (error.message === "Network Error") throw new NoConnectionError()
  if (error.response === undefined) throw error

  console.log(error.response)

  throw new RequestError(error.response)
}

if (window.location.pathname.includes("chat-bot")) {
  const root = createRoot(document.getElementById("app-root")!)
  root.render(
    <React.StrictMode>
      <NoUserContextAppProviders>
        <MainWrapper>
          <Routes>
            <Route path="chat-bot/:chatId" element={<ChatBotPage />} />
          </Routes>
        </MainWrapper>
      </NoUserContextAppProviders>
    </React.StrictMode>
  )
} else {
  UserService.initKeycloak(() => {
    const root = createRoot(document.getElementById("app-root")!)
    root.render(
      <React.StrictMode>
        <AppProviders>
          <BiPortalApp />
        </AppProviders>
      </React.StrictMode>
    )
  })
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
